<template> 
      <v-card
        class="mt-4 mb-12 mx-0"
        elevation="0"
        max-height="700"
        width="510"
      >
        <v-sheet
          class="v-sheet--offset mx-auto"
          color="cyan"
          elevation="0"
          max-width="calc(100% - 32px)"
        >   
          <v-sparkline
            :labels="labels"
            :value="value"
            color="white"
            line-width="2"
            padding="16"
          ></v-sparkline>
        </v-sheet>

        <v-card-text class="pt-0">
          <div class="title font-weight-light mb-2">
            Volunteer Registrations
          </div>
          <div class="subheading font-weight-light grey--text">
            24 Hours Performance
          </div>
          <v-divider class="my-2"></v-divider>
          <v-icon class="mr-2" small> mdi-clock </v-icon>
          <span class="caption grey--text font-weight-light"
            >last registration {{date}} minutes ago</span
          >
        </v-card-text>
        <!--
        <v-card-actions>
          <v-btn 
                  outlined
                  rounded
                  small text  color="primary" @click="show = true">
            Recent Volunteers
          </v-btn>
        </v-card-actions> -->
        <!-- The Volunteers List Table -->
        <v-expand-transition>
          <v-card
            v-if="show"
            class="transition-fast-in-fast-out v-card--reveal mx-0 scroll-vertical"
            style="height: 100%"
            width="100%"
            max-height="500px"
            elevation="0"
          >
            <v-data-table
              :headers="headers"
              :items="users"
              :items-per-page="10"
              class="elevation-0"
            >
              <!-- Customizing the DataTable with avatar -->
              <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar color="primary_whiten" size="38" class="avatar-style">
                  <span class="white--text headline">{{ item.avatar }}</span>
                </v-avatar>
              </template>
            </v-data-table>
            <v-card-actions class="pt-0">
              <v-btn text color="orange accent-4" @click="show = false">
                Chart
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expand-transition>
      </v-card> 
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "LatestRegisteredVolunteers",
  async created() {
    await this.fetchLatestVolunteers();
  },
  computed: {
    ...mapFields("volunteers", ["latestVolunteers"]),
  },
  data: () => ({
    // detect date now
    date: new Date(), 
    show: false,
    labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
    value: [200, 675, 410, 390, 310, 460, 250, 240],
    headers: [
      {
        text: "Avatar",
        align: "start",
        sortable: false,
        value: "avatar",
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Phone", value: "phone" },
      { text: "Country", sortable: false, value: "country" },
      { text: "City", value: "city" },
    ],
    users: [],
  }),
  methods: {
    ...mapActions("volunteers", ["fetchLatestVolunteers"]),
  },
  watch: {
    latestVolunteers: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((volunteer) => {
            this.users.push({
              avatar: "ET",
              name: volunteer.name,
              phone: volunteer.phone_number,
              country: volunteer.country,
              city: volunteer.city,
            });
          });
        }
      },
    },
  },
};
</script>
<style scoped>
.v-sheet--offset {
  top: 0px;
  position: relative;
}
</style>